/* import {CustomCheckbox} from
    "./../../classes/customCheckbox/CustomCheckbox.js"; */

export function getCustomCheckbox(inputObj){
	
/* 	const customCheckbox = new CustomCheckbox();

	customCheckbox.extra_class = inputObj["extra_class"]+" "+inputObj["readableClass"];
	customCheckbox.isChecked = inputObj["isChecked"];
	customCheckbox.label =  inputObj["placeholder"]; 
	customCheckbox.createErrorHolder = inputObj["createerrorHolder"];
	customCheckbox.errorHolderClass = inputObj["errorHolderClass"];

	let output = customCheckbox.render();

	return output; */

};